import React from 'react'

const styles = {
  container: {
    width: '100%',
  },
  header: {
    display: 'flex',
    gap: 0,
    borderBottom: '2px solid #e0e0e0',
    marginBottom: 24,
  },
  tab: (active) => ({
    background: 'none',
    border: 'none',
    borderBottom: active ? '2px solid #333' : '2px solid transparent',
    marginBottom: -2,
    padding: '8px 16px',
    cursor: 'pointer',
    fontWeight: active ? 600 : 400,
    color: active ? '#333' : '#888',
    fontSize: 14,
    transition: 'color 0.15s, border-color 0.15s',
    whiteSpace: 'nowrap',
  }),
}

export function Tabs({ activeIndex, setActiveIndex, children }) {
  return (
    <div style={styles.container}>
      <div style={styles.header}>
        {React.Children.map(children, (child, index) => (
          <button style={styles.tab(activeIndex === index)} onClick={() => setActiveIndex(index)}>
            {child.props.label}
          </button>
        ))}
      </div>
      <div>{React.Children.toArray(children)[activeIndex]}</div>
    </div>
  )
}

export function TabPanel({ children }) {
  return <div>{children}</div>
}
